import { render, staticRenderFns } from "./FormatoInspeccionExport.vue?vue&type=template&id=3477bd1d"
import script from "./FormatoInspeccionExport.vue?vue&type=script&lang=js"
export * from "./FormatoInspeccionExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports